import React from 'react'
import {Link} from '@inertiajs/inertia-react'

export default function PageLink({link}) {
    if(link.active===true){
        return <Link href={link.url} aria-current="page" className="z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium"> {link.label} </Link>
    }
    return <Link href={link.url} className="bg-white border-gray-300 text-gray-500 hover:bg-gray-50 relative inline-flex items-center px-4 py-2 border text-sm font-medium"> {link.label} </Link>
}
